class HolidayCalendar {
  constructor() {
    this.holidays = [];
    this.currentDate = new Date();
    this.calendarCache = new Map();
    this.lastUpdate = null;
  }

  setHolidays(holidayDates) {
    this.holidays = holidayDates.map(date => new Date(date));
  }

  isHoliday(date) {
    const isWeekend = date.getDay() === 0 || date.getDay() === 6;
    const isSpecialHoliday = this.holidays.some(holiday => 
      holiday.getFullYear() === date.getFullYear() && 
      holiday.getMonth() === date.getMonth() && 
      holiday.getDate() === date.getDate()
    );
    return isWeekend || isSpecialHoliday;
  }

  generateMonthCalendar(date) {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    const weekdays = ['日', '月', '火', '水', '木', '金', '土'];
    
    let calendarHTML = `
      <div class="calendar">
        <h3>${year}年${month + 1}月</h3>
        <div class="calendar-grid" role="grid" aria-label="${year}年${month + 1}月のカレンダー">
          ${weekdays.map(day => 
            `<div class="calendar-header" role="columnheader">${day}</div>`
          ).join('')}
    `;

    // 月初めの空白セル
    for (let i = 0; i < firstDay.getDay(); i++) {
      calendarHTML += '<div class="calendar-cell empty" role="gridcell"></div>';
    }

    // 日付セル
    for (let day = 1; day <= lastDay.getDate(); day++) {
      const currentDate = new Date(year, month, day);
      const isHoliday = this.isHoliday(currentDate);
      
      // 今日の日付かどうかをチェック
      const today = new Date();
      const isToday = currentDate.getDate() === today.getDate() && 
                     currentDate.getMonth() === today.getMonth() && 
                     currentDate.getFullYear() === today.getFullYear();

      const ariaLabel = `${year}年${month + 1}月${day}日 ${isHoliday ? '休業日' : '営業日'}`;
      
      calendarHTML += `
        <div class="calendar-cell ${isHoliday ? 'holiday' : ''} ${isToday ? 'today' : ''}"
             role="gridcell"
             aria-label="${ariaLabel}"
             ${isToday ? 'aria-current="date"' : ''}>
          ${day}
        </div>
      `;
    }

    // 月末の空白セル
    const lastDayOfWeek = lastDay.getDay();
    const remainingCells = 6 - lastDayOfWeek;
    for (let i = 0; i < remainingCells; i++) {
      calendarHTML += '<div class="calendar-cell empty" role="gridcell"></div>';
    }

    calendarHTML += `
        </div>
      </div>
    `;

    return calendarHTML;
  }

  generateCalendar() {
    const container = document.getElementById('holiday-calendar');
    if (!container) return;

    const now = new Date();
    const cacheKey = `${now.getFullYear()}-${now.getMonth()}`;
    
    // 1日1回だけ更新
    if (this.lastUpdate && 
        this.lastUpdate.toDateString() === now.toDateString() &&
        this.calendarCache.has(cacheKey)) {
      container.innerHTML = this.calendarCache.get(cacheKey);
      return;
    }

    const currentMonth = this.generateMonthCalendar(this.currentDate);
    const nextMonth = this.generateMonthCalendar(
      new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1)
    );

    const calendarHTML = `
      <div class="calendar-container">
        ${currentMonth}
        ${nextMonth}
      </div>
    `;

    container.innerHTML = calendarHTML;
    this.calendarCache.set(cacheKey, calendarHTML);
    this.lastUpdate = now;
  }
}

// セクションのリロード時にカレンダーを初期化
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('#holiday-calendar')) {
    initializeCalendar();
  }
});

// ページ読み込み時にカレンダーを初期化
document.addEventListener('DOMContentLoaded', initializeCalendar);

// カレンダーの初期化関数
// カレンダーの日付設定
function initializeCalendar() {
  const calendar = new HolidayCalendar();
  calendar.setHolidays([
    '2024-12-30',
    '2024-12-31',
    '2025-01-01',
    '2025-01-02',
    '2025-01-03',
    '2025-01-13',
    '2025-02-11',
    '2025-02-24',
    '2025-03-20',
    '2025-04-29',
    '2025-05-05',
    '2025-05-06',
'2025-07-04',
'2025-08-11',
'2025-08-13',
'2025-08-14',
'2025-08-15',
'2025-09-15',
'2025-09-23',
'2025-10-13',
'2025-11-03',
'2025-11-24',
'2025-12-29',
'2025-12-30',
'2025-12-31',
'2026-01-01',
'2026-01-02',
'2026-01-12',
'2026-01-22',
'2026-02-11',
'2026-02-23',
'2026-03-20',
'2026-04-29',
'2026-05-04',
'2026-05-05',
'2026-05-06',
'2026-07-20',
'2026-08-11',
'2026-08-12',
'2026-08-13',
'2026-08-14',
'2026-09-21',
'2026-09-22',
'2026-09-23',
'2026-10-12',
'2026-11-03',
'2026-11-23',
'2026-12-29',
'2026-12-30',
'2026-12-31',
'2027-01-01',
'2027-01-11',
'2027-02-11',
'2027-02-23',
'2027-03-22',
'2027-04-29',
'2027-05-03',
'2027-05-04',
'2027-05-05'
  ]);
  calendar.generateCalendar();
}